import cx from 'classnames';
import Header from 'components/layouts/Header/Header';
import { SocialMediaButtons } from 'components/SocialMedia';
import React from 'react';

import Styles from './styles.module.scss';

export function BankxDashboardLayout(props: React.PropsWithChildren): React.ReactElement {
    return (
        <div className={cx(Styles.container, 'body-dark')}>
            <div className={Styles.header}>
                <Header
                    hasConnectButton={true}
                    hasDarkmodeBtn={false}
                    hasExandedLogo={true}
                    isDarkTheme={true}
                    hasSocialMediaButtons={true}
                />
            </div>
            <div className={Styles.body}>
                {props.children}
            </div>
            <div className={Styles.footer}>
                <SocialMediaButtons />
            </div>
        </div>
    );
}
